<template>
    <!-- Slider main container -->
    <div class="swiper main-swiper-container">
        <!-- Additional required wrapper -->
        <div :class="['fixed-slide-title',{'mob-title':!isPc}]">{{ title }}</div>
        <div v-if="sliderList.length" class="swiper-wrapper">
            <!-- Slides -->
            <div class="swiper-slide" v-for="(item, index) in sliderList" :key="index">
                <img class="swiper-slide-image swiper-lazy loading-bg" :data-src="showImg(item)+'.webp'" alt="">
                <div class="swiper-lazy-preloader"></div>
                <div class="swiper-slide-content">
                    <div :class="['slide-text-container',{'mob-text-container':!isPc}]">
                        <p :class="['slide-desc',{'mob-desc':!isPc}]">{{ item.desc }}</p>
                    </div>
                    <div class="swiper-mask"></div>
                </div>
            </div>
        </div>
        <!-- If we need pagination -->
        <div class="swiper-pagination"></div>
    </div>
</template>

<script>
import Swiper from '@pc/components/libs/swiper/swiper.6.5.0.js'
import '@pc/components/libs/swiper/swiper.6.5.0.css'
import { dataReport } from "../../../../../../utils/report";
export default {
    props: {
        swiperInfo: {
            type: Array,
            default: () => ([])
        },
        isPc: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            mobImg:[
                'https://coss-platform.fenqile.com/platformresource200/M00/ex/20251107105543-1e2daa06-2c56-40d2-a814-5d6b1afe1f5d.png',
                'https://coss-platform.fenqile.com/platformresource200/M00/ex/20251107105617-d5c2dd6f-468b-42b8-b001-1de419cd8d25.png',
                'https://coss-platform.fenqile.com/platformresource200/M00/ex/20251107105648-a4d0c852-afef-4d75-87b7-2112a7bb6ad5.png',
                'https://coss-platform.fenqile.com/platformresource200/M00/ex/20251107105714-a92c7cff-8994-4513-9598-d8c748bb8aaf.png'
            ]
        };
    },
    computed: {
        title() {
            return this.swiperInfo?.[0]?.[0]?.title || '超两亿用户的信赖之选'
        },
        sliderList() {
            if (!this.swiperInfo?.[1]?.length) {
                return [
                    {
                        "$material_name": "fql普惠",
                        "$material_create_time": 1757504165000,
                        "img": "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250915113644-cddf4892-4840-40ba-b1b3-14b0235fd1fe.png",
                        "$material_sort": 1,
                        "$material_biz_type": "platform",
                        "$material_id": "M2025091019360585677",
                        "title": "超2亿用户的信赖之选",
                        "desc": "“分期乐普惠助我开潮州首家Tufting店，圆了创业梦”"
                    },
                    {
                        "$material_name": "fql无人机",
                        "$material_create_time": 1757504219000,
                        "img": "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250915113653-2081425f-c5d3-4f4c-963d-b067d38f044e.png",
                        "$material_sort": 2,
                        "$material_biz_type": "platform",
                        "$material_id": "M2025091019365975231",
                        "title": "超2亿用户的信赖之选",
                        "desc": "“当无人机飞起时，我确定这就是我想要的生活方式”"
                    },
                    {
                        "$material_name": "fql借钱",
                        "$material_create_time": 1757504748000,
                        "img": "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250915113702-8221e2b9-6974-4e93-9fde-ffd6904538e5.png",
                        "$material_sort": 3,
                        "$material_biz_type": "platform",
                        "$material_id": "M2025091019454893090",
                        "title": "超2亿用户的信赖之选",
                        "desc": "“在分期乐借钱启动创业，我从钢厂走进带货直播间。”"
                    },
                    {
                        "$material_name": "fql房租",
                        "$material_create_time": 1757504800000,
                        "img": "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250915113719-f01e55dc-613f-4968-b6a4-5cda6096972e.png",
                        "$material_sort": 4,
                        "$material_biz_type": "platform",
                        "$material_id": "M2025091019464061440",
                        "title": "超2亿用户的信赖之选",
                        "desc": "“用分期乐付房租，在异地成功入职理想的制糖企业”"
                    }
                ]
            }

            return this.swiperInfo?.[1]?.map((item,index) => ({
                title: item?.title,
                desc: item?.desc,
                img: item?.img,
                img2: item?.img_mob
            }))
        }
    },
    methods: {
        showImg(item) {
            return this.isPc ? item.img : item.img2
        },
        initSwiper() {
            this.$nextTick(() => {
                new Swiper('.main-swiper-container', {
                    // Optional parameters
                    direction: 'horizontal',
                    loop: true,
                    // autoplay: {
                    //     delay: 6000,
                    //     disableOnInteraction: false,
                    // },
                    // If we need pagination
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    lazy: {
                        loadPrevNext: true, // 预加载前后图片
                        loadOnTransitionStart: false, // 切换时开始加载
                    },
                    preloadImages: false
                });
            });

        }

    },
    watch: {
        swiperInfo: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    dataReport({
                        hottag: 'FQL_HOME_SWIPER_LOAD',
                        eventPosName: `分期乐首页swiper加载`,
                        eventType: 1, 
                    })
                    // 确保数据存在，再初始化 Swiper
                    this.$nextTick(() => {
                        this.initSwiper();
                    });
                }
            },
            immediate: true, // 立即执行一次
            deep: true
        }
    },
    // mounted() {
    //     this.initSwiper()
    // },
};
</script>

<style scoped>
.swiper-lazy-preloader {
    opacity: 0;
}

/* 固定标题样式 */
.fixed-slide-title {
    position: absolute;
    top: 60%; /* 调整垂直位置（与原标题对齐） */
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 20; /* 确保在蒙层上方 */
    color: white;
    font-size: 62px;
    font-weight: 500;
    margin: 0;
}

.mob-title {
    font-size: 24px;
    white-space: nowrap;
    top: 74%;
}

.main-swiper-container {
    position: relative;
    width: 100%;
    min-height: 400px;
}

.swiper-slide-image {
    width: 100%;
    height: auto;
}

.swiper-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.5;
    z-index: 10;
}

.swiper-slide {
    position: relative;
}

.slide-text-container {
    width: 100%;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 20;
    /* 高于蒙层的z-index值 */
    color: white;
    /* 设置文本颜色 */
}

.mob-text-container {
    top: 68%;
}

.slide-title {
    margin: 0 0 10px 0;
    font-size: 62px;
    font-weight: 600;
}

.slide-desc {
    font-family: 'PingFang SC';
    opacity: 0;
    transform: translateY(20px); /* 轻微下移增强过渡效果 */
    transition: opacity 0.8s ease, transform 0.8s ease;
    margin: 0;
    font-size: 34px;
    font-weight: 400;
}

.mob-desc {
    font-size: 12px;
    white-space: nowrap;
    margin-top: 32%;
}

/* 激活状态的slide描述文本渐入 */
.swiper-slide-active .slide-desc {
    opacity: 1;
    transform: translateY(0);
}

::v-deep .swiper-pagination-bullet{
    opacity: 1;
    background: #fff;
}

/* 分页器激活状态样式 */
::v-deep .swiper-pagination-bullet-active {
    width: 24px;
    /* 激活状态宽度（可改为椭圆） */
    background: #407AFF;
    /* 激活状态颜色（纯白色） */
    border-radius: 8px;
    /* 椭圆边角（若需要圆形可保持50%） */
}

/* 轮播图加载状态背景色 */
.swiper-slide-image.loading-bg {
    /* 设置背景色（可替换为需要的颜色值） */
    background-color: #f5f5f5;
    /* 确保容器高度，避免塌陷（与轮播容器高度一致） */
    min-height: 330px;
}

/* 图片加载完成后移除背景色 */
.swiper-slide-image.swiper-lazy-loaded.loading-bg {
    background-color: transparent;
}
</style>